import React from 'react';
import PropTypes from 'prop-types';
import TextareaAutosize from 'react-autosize-textarea';
import Select from 'react-select-legacy';
import FilterCheckbox from 'components/filters/FilterCheckbox';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';

const BulkMessage = ({ message, filters, onChange, onCardChange, onProgramContentChange }) => {
  const { t } = useTranslation();
  const { body, bodyEs, pushTitle, pushTitleEs, pushText, pushTextEs, programContentEntryIds, cardIds, sendInaccessibleAttachedContent } = message;
  return (
    <div className='column small-12'>
      <label>
        {t('bulkSending.english')}
        <TextareaAutosize name='body' value={body} onChange={onChange} />
      </label>
      <label>
        {t('bulkSending.spanish')}
        <TextareaAutosize name='bodyEs' value={bodyEs} onChange={onChange} />
      </label>
      <div className='row u-margin-bottom--base'>
        <div className='column small-12 medium-6'>
          <label>
            {t('bulkSending.pushTitle')}
            <input name='pushTitle' type='text' value={pushTitle} onChange={onChange} />
          </label>
        </div>
        <div className='column small-12 medium-6'>
          <label>
            {t('bulkSending.pushTitleSpanish')}
            <input name='pushTitleEs' type='text' value={pushTitleEs} onChange={onChange} />
          </label>
        </div>
        <div className='column small-12 medium-6'>
          <label>
            {t('bulkSending.pushText')}
            <input name='pushText' type='text' value={pushText} onChange={onChange} />
          </label>
        </div>
        <div className='column small-12 medium-6'>
          <label>
            {t('bulkSending.pushTextSpanish')}
            <input name='pushTextEs' type='text' value={pushTextEs} onChange={onChange} />
          </label>
        </div>
      </div>
      <div className='row u-margin-bottom--base'>
        <div className='column small-12 medium-6'>
          <Select
            name='sp-cards-select'
            className={'o-select o-select--optgroup'}
            disabled={!isEmpty(programContentEntryIds)}
            multi={true}
            value={cardIds || []}
            onChange={onCardChange}
            options={filters.cards}
            placeholder={t('bulkSending.cardsPlaceholder')}/>
        </div>
        <div className='column small-12 medium-6'>
          <Select
            name='sp-pc-select'
            className={'o-select o-select--optgroup'}
            disabled={!isEmpty(cardIds)}
            multi={true}
            value={programContentEntryIds || []}
            onChange={onProgramContentChange}
            options={filters.pcs}
            placeholder={t('bulkSending.tipsPlaceholder')}/>
        </div>
      </div>
      <div className='row u-margin-bottom--base'>
        <div className='column small-12 medium-12'>
          <FilterCheckbox label={t('bulkSending.sendInaccessible')} value={sendInaccessibleAttachedContent || false} onChange={(value) => {
            onChange({
              target: {
                name: "sendInaccessibleAttachedContent",
                value: value,
              }
            });
          }}/>
        </div>
      </div>
    </div>
  );
}

BulkMessage.propTypes = {
  filters: PropTypes.object.isRequired,
  message: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onCardChange: PropTypes.func.isRequired,
  onProgramContentChange: PropTypes.func.isRequired,
}

export default BulkMessage;
